import { HomeWorkPage } from './HomeWorkPage';
export default HomeWorkPage;
